import React from "react";
import { Button } from "@culturehq/components";
import { Trans } from "app/utils";
import { OrganizationJobMapperRole } from "chq";

import { TimeDiff } from "components/common/Time";
import ChqModalConfirmDelete from "components/common/ChqModalConfirmDelete";

interface OrganizationMapperRoleRowProps {
  mapperRole: OrganizationJobMapperRole;
  onDelete: (mapperRole: OrganizationJobMapperRole) => void;
}

const OrganizationMapperRoleRow = ({
  mapperRole,
  onDelete
}: OrganizationMapperRoleRowProps) => (
  <tr>
    <td>
      <Trans>{mapperRole.role}</Trans>
    </td>
    <td>
      <TimeDiff time={mapperRole.createdAt} />
    </td>
    <td className="Actions-column">
      <ChqModalConfirmDelete
        onAccept={() => onDelete(mapperRole)}
        trigger={(onTrigger: any) => (
          <Button icon="trash-a-outlined" onClick={onTrigger} inverted />
        )}
      >
        <Trans>
          Are you sure you would like to delete this mapper role?
        </Trans>
      </ChqModalConfirmDelete>
    </td>
  </tr>
);

export default OrganizationMapperRoleRow;
